import {MenuCategory} from "./Menu";

export class SubOrder {
  constructor() {
    this.attendeeId = null;
    this.orderUuid = null;
    this.uuid = null;
    this.subCategories = [];
    this.status = null;
    this.savedCategories = [];
    this.selectedCharacter = [];
  }

  map(order) {
    if (order.attendee_id) this.attendeeId = order.attendee_id;
    if (order.order_uuid) this.orderUuid = order.order_uuid;
    if (order.uuid) this.uuid = order.uuid;
    if (order.status) this.status = order.status;
    if (order.sub_order_categories) this.subCategories = order.sub_order_categories.map(category => new MenuCategory().map(category))

    return this;
  }

  update(order) {
    if (order.attendeeId) this.attendeeId = order.attendeeId;
    if (order.orderUuid) this.orderUuid = order.orderUuid;
    if (order.uuid) this.uuid = order.uuid;
    if (order.subCategories) this.subCategories = [...order.subCategories]
    if (order.status) this.status = status;

    return this;
  }
}
